import urlJoin from 'url-join';
import { AppSettings } from 'core/AppSettings';
import { getHubLoginUrl, hasHubSourceMarker } from './getHubLoginUrl';

export function getLoginUrl(): string {
  if (hasHubSourceMarker()) {
    return getHubLoginUrl();
  }
  return urlJoin(AppSettings.authUrl, `?ReturnUrl=${encodeURI(AppSettings.omnisUrl)}`);
}
